<template>
  <div>
    <CCard class="bg-style2">
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              :fields="fields"
              :items="pendingRequests"
              :items-per-page="small ? 50 : 20"
              :dark="dark"
              pagination
            >
              <template #index="{index}">
                <td class="mt-3">
                  <label>{{ index + 1 }}</label>
                </td>
              </template>

              <template #description="{item}">
                <td class="mt-3">
                  <span>{{ item.description }}</span>
                </td>
              </template>

              <template #assetName="{item}">
                <td class="mt-3">
                  <label>{{ item.assetName }}</label>
                </td>
              </template>

              <template #amount="{item}">
                <td class="mt-3">
                  <span>{{ item.amount }}</span>
                </td>
              </template>

              <template #status="{item}">
                <td class="mt-3">
                  <span>{{ item.status }}</span>
                </td>
              </template>

              <template #action="{item}">
                <td style="width: 200px">
                  <CRow>
                    <CCol class="text-center">
                      <template v-if="item.status === 'pending'">
                        <CButton
                          class="mr-1"
                          size="sm"
                          color="success"
                          shape="pill"
                          variant="outline"
                          @click="confirmApprove(item)"
                        >
                          <CIcon name="cil-check"/>
                        </CButton>
                        <CButton
                          class="mr-1"
                          size="sm"
                          color="danger"
                          shape="pill"
                          variant="outline"
                          @click="confirmReject(item)"
                        >
                          <CIcon name="cil-x"/>
                        </CButton>
                      </template>
                    </CCol>
                  </CRow>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'AssetsApproval',
  props: {
    icon: { type: String, default: 'cil-clipboard' },
    caption: { type: String, default: 'อนุมัติสินทรัพย์' },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "description", label: "รายละเอียดคำขอ"},
          {key: "assetName", label: "ชื่อสินทรัพย์"},
          {key: "amount", label: "จำนวนที่ขอ"},
          {key: "status", label: "สถานะ"},
          {key: "action", label: "การทำงาน", _style: 'width:200px; text-align: center'},
        ]
      }
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },

  data() {
    return {
      pendingRequests: []
    }
  },

  computed: {
    ...mapGetters({
      assets: 'Assets/assets',
      reports: 'Dashboard/reports', // ดึง report ทั้งหมด
    }),
  },

  watch: {
    assets: {
      handler() {
        this.refreshPendingRequests()
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    refreshPendingRequests() {
      const requests = []
      this.assets.forEach(asset => {
        (asset.history || []).forEach(h => {
          if (h.status === 'pending') {
            const report = this.reports.find(r => r._id === h.report)
            requests.push({
              _id: asset._id,
              description: report ? report.description : '',
              assetName: Array.isArray(asset.title) ? asset.title.map(t => t.value).join(", ") : asset.title,
              amount: h.amount,
              status: h.status,
              report: h.report
            })
          }
        })
      })
      this.pendingRequests = requests
    },



    confirmApprove(item) {
      Swal.fire({
        title: 'คุณต้องการอนุมัติสินทรัพย์นี้?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'อนุมัติ',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#28a745',
      }).then(result => {
        if (result.isConfirmed) {
          this.approve(item)
        }
      })
    },

    confirmReject(item) {
      Swal.fire({
        title: 'คุณต้องการไม่อนุมัติสินทรัพย์นี้?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ไม่อนุมัติ',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#dc3545',
      }).then(result => {
        if (result.isConfirmed) {
          this.reject(item)
        }
      })
    },

    async approve(item) {
      try {
        const asset = this.assets.find(a => a._id === item._id)
        if (!asset) return

        const updatedHistory = (asset.history || []).map(h => {
          if (h.report === item.report) return { ...h, status: 'approved', state: false }
          return h
        })
        await this.$store.dispatch('Assets/update', { _id: asset._id, history: updatedHistory })
        await this.$store.dispatch('Dashboard2/logCaseAction', {
          caseId: item.report,
          by: "ผู้ใช้ระบบ", 
          assetId: asset._id,
          assetAction: "approved",
          reason: `อนุมัติ ${Array.isArray(asset.title) ? asset.title.map(t=>t.value).join(", ") : asset.title}`
        })

        this.refreshPendingRequests()
        Swal.fire('อนุมัติแล้ว', '', 'success')
      } catch (err) {
        console.error('approve error', err)
        Swal.fire('เกิดข้อผิดพลาด', '', 'error')
      }
    },

    async reject(item) {
      try {
        const asset = this.assets.find(a => a._id === item._id)
        if (!asset) return

        const updatedHistory = (asset.history || []).map(h => {
          if (h.report === item.report) return { ...h, status: 'rejected', state: null }
          return h
        })
        await this.$store.dispatch('Assets/update', { _id: asset._id, history: updatedHistory })
        await this.$store.dispatch('Dashboard2/logCaseAction', {
          caseId: item.report,
          by: "ผู้ใช้ระบบ",
          assetId: asset._id,
          assetAction: "rejected",
          reason: `ไม่อนุมัติ ${Array.isArray(asset.title) ? asset.title.map(t=>t.value).join(", ") : asset.title}`
        })

        this.refreshPendingRequests()
        Swal.fire('ไม่อนุมัติแล้ว', '', 'success')
      } catch (err) {
        console.error('reject error', err)
        Swal.fire('เกิดข้อผิดพลาด', '', 'error')
      }
    },
  }
}
</script>
